const GLOBAL_CONFIG = 'GLOBAL_CONFIG'
const GAME_LIST = 'GAME_LIST'
const DELAY_TIME = 100
const LANGUAGE = 'LANGUAGE'
const WX_INFO = 'WX_INFO'
const LOGO = 'LOGO'
const VISIBLE = 'VISIBLE'
const ICO = 'ICO'
const TITLE = 'TITLE'

export { GLOBAL_CONFIG, GAME_LIST, DELAY_TIME, LANGUAGE, WX_INFO, LOGO, VISIBLE, ICO,TITLE}
